// extracted by mini-css-extract-plugin
module.exports = {"title":"Accordion_title__362WK","component":"Accordion_component__2jCc0","wrapper":"Accordion_wrapper__3biUb","text":"Accordion_text__39Vpa"};